export default {
    model: {
        email: {
            label: "Correo electrónico",
            placeholder: "Nombre o correo electrónico del delegado",
            notFound: "Usuarios no encontrados"
        },
        start_on: {
            label: "Fecha de inicio",
            placeholder: "Fecha de inicio de la delegación"
        },
        end_on: {
            label: "Fecha de finalización",
            placeholder: "Opcional"
        },
        accept: {
            tip: "Al delegar su responsabilidad de aprobación, usted certifica que asume la responsabilidad de cualquier orden aprobada por su delegado.",
            label: "Acepto"
        }
    },
    buttons: {
        submit: {
            cta: "Confirmar",
            processing: "Ahorro"
        },
        close: {
            cta: "Cancelar"
        }
    },
    saved: "Guardado"
}